import { defineComponent as _defineComponent } from 'vue';
import { createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, unref as _unref, openBlock as _openBlock, createBlock as _createBlock } from "vue";
import { watch } from "vue";
import { useAuthStatus } from "./composables/useAuthStatus";
import { useLogout } from "./composables/useLogout";
import { useRouter } from "vue-router";
import MenuList from "./components/menu/MenuList.vue";
export default /*@__PURE__*/ _defineComponent({
    __name: 'App',
    setup(__props) {
        const { isLoggedIn, isLoading, error } = useAuthStatus();
        const { logout } = useLogout();
        const router = useRouter();
        watch(() => error.value, () => {
            if (error.value) {
                // ログイン画面に遷移させる
                router.push("/login");
            }
        });
        return (_ctx, _cache) => {
            const _component_router_link = _resolveComponent("router-link");
            const _component_v_app_bar = _resolveComponent("v-app-bar");
            const _component_v_icon = _resolveComponent("v-icon");
            const _component_v_list_item_title = _resolveComponent("v-list-item-title");
            const _component_v_list_item = _resolveComponent("v-list-item");
            const _component_v_list = _resolveComponent("v-list");
            const _component_v_navigation_drawer = _resolveComponent("v-navigation-drawer");
            const _component_router_view = _resolveComponent("router-view");
            const _component_v_main = _resolveComponent("v-main");
            const _component_v_app = _resolveComponent("v-app");
            return (_openBlock(), _createBlock(_component_v_app, null, {
                default: _withCtx(() => [
                    _createVNode(_component_v_app_bar, {
                        app: "",
                        color: "primary"
                    }, {
                        default: _withCtx(() => [
                            _createVNode(_component_router_link, { to: "/" }, {
                                default: _withCtx(() => _cache[0] || (_cache[0] = [
                                    _createTextVNode("WorksSupport")
                                ])),
                                _: 1,
                                __: [0]
                            })
                        ]),
                        _: 1
                    }),
                    _createVNode(_component_v_navigation_drawer, {
                        "expand-on-hover": "",
                        rail: "",
                        color: "secondary"
                    }, {
                        default: _withCtx(() => [
                            (_unref(isLoggedIn))
                                ? (_openBlock(), _createBlock(MenuList, { key: 0 }))
                                : (_openBlock(), _createBlock(_component_v_list, { key: 1 }, {
                                    default: _withCtx(() => [
                                        _createVNode(_component_v_list_item, { to: "/login" }, {
                                            default: _withCtx(() => [
                                                _createVNode(_component_v_list_item_title, null, {
                                                    default: _withCtx(() => [
                                                        _createVNode(_component_v_icon, null, {
                                                            default: _withCtx(() => _cache[1] || (_cache[1] = [
                                                                _createTextVNode("mdi-login")
                                                            ])),
                                                            _: 1,
                                                            __: [1]
                                                        }),
                                                        _cache[2] || (_cache[2] = _createTextVNode("ログイン"))
                                                    ]),
                                                    _: 1,
                                                    __: [2]
                                                })
                                            ]),
                                            _: 1
                                        })
                                    ]),
                                    _: 1
                                }))
                        ]),
                        _: 1
                    }),
                    _createVNode(_component_v_main, { id: "main-page" }, {
                        default: _withCtx(() => [
                            _createVNode(_component_router_view)
                        ]),
                        _: 1
                    })
                ]),
                _: 1
            }));
        };
    }
});
